import { findOrderSummary } from "../../../Common/ProductWiseSkuPdf/utils/productWiseSkuPdfUtils";

// Billing load sheet UOM cell: primaryValue, else secondaryValue.
export const getLoadSheetUomQty = (summary) => {
  if (!summary) {
    return 0;
  }
  if (summary.totalQty != null && summary.totalQty != 0) {
    return summary.totalQty;
  }
  return 0;
};

// Billing load sheet All column: sum totalQty per UOM match.
export const getLoadSheetProductAllQty = (product, uomList, orderSummaries) =>
  (uomList || []).reduce((allQty, uom) => {
    const summary = findOrderSummary(orderSummaries, product.id, uom.id);
    if (summary && summary.totalQty != null) {
      return allQty + summary.totalQty;
    }
    return allQty;
  }, 0);
